import React, { Fragment, useEffect } from 'react';
import Link from 'shared/SlashLink';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

const NotFoundPage = () => {
    usePageSeo({
        title: 'Page Not Found (404)',
        description: 'The page you are looking for could not be found. Explore BUILDLAB technology consulting and design services, the California affordable housing pipeline, or get in touch.',
    });

    // 404s should not be indexed.
    useEffect(() => {
        let tag = document.querySelector('meta[name="robots"]');
        const had = !!tag;
        const prev = tag?.getAttribute('content');
        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('name', 'robots');
            document.head.appendChild(tag);
        }
        tag.setAttribute('content', 'noindex, follow');
        return () => {
            if (had && prev) tag.setAttribute('content', prev);
            else if (tag && tag.parentNode) tag.parentNode.removeChild(tag);
        };
    }, []);

    const ClickHandler = () => window.scrollTo(10, 0);

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content">
                <PageTitle pageTitle={'Page Not Found'} pagesub={'404'} pageTop={'Error'} />
                <section className="section_space bg-light">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h2 className="mb-3">We couldn't find that page</h2>
                                <p className="mb-4">
                                    The link may be broken or the page may have moved. Here are a few good places to pick
                                    back up:
                                </p>
                                <div className="d-flex flex-wrap justify-content-center" style={{ gap: 12 }}>
                                    <Link onClick={ClickHandler} to="/" className="btn btn-primary">
                                        <span className="btn_label" data-text="Go to homepage">Go to homepage</span>
                                        <span className="btn_icon"><i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i></span>
                                    </Link>
                                    <Link onClick={ClickHandler} to="/housing-pipeline" className="btn btn-outline-dark">
                                        <span className="btn_label" data-text="Housing Pipeline">Housing Pipeline</span>
                                    </Link>
                                    <Link onClick={ClickHandler} to="/it-services" className="btn btn-outline-dark">
                                        <span className="btn_label" data-text="IT Services">IT Services</span>
                                    </Link>
                                    <Link onClick={ClickHandler} to="/contact" className="btn btn-outline-dark">
                                        <span className="btn_label" data-text="Contact us">Contact us</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default NotFoundPage;
